import AdminModel from '@/models/Admin';
import PromModel from '@/models/Prom';

const SIGNUP_LOGIN = 'SIGNUP_LOGIN';
const SIGNUP_DETAIL = 'SIGNUP_DETAIL';
const SIGNUP_CANCEL = 'SIGNUP_CANCEL';
const SIGNUP_RESULT = 'SIGNUP_RESULT';
const SIGNUP_SUBMIT = 'SIGNUP_SUBMIT';
const SIGNUP_PREVIEW_DETAIL = 'SIGNUP_PREVIEW_DETAIL';
const SIGNUP_STATUS = 'SIGNUP_STATUS';
const GET_RULE = 'GET_RULE';

// 报名登录
async function signupLogin(params) {
  const payload = await new AdminModel().signupLogin(params);
  return {
    type: SIGNUP_LOGIN,
    payload
  }
}

async function getRule(params) {
  const payload = await new AdminModel().getRule(params);
  return {
    type: GET_RULE,
    payload
  }
}

// 查看活动题目
async function signupDetail(params) {
  const payload = await new PromModel().signupDetail(params);
  return {
    type: SIGNUP_DETAIL,
    payload
  }
}

// 用户取消报名
async function signupCancel(params) {
  const payload = await new PromModel().signupCancel(params);
  return {
    type: SIGNUP_CANCEL,
    payload
  }
}

// 用户报名结果页
async function signupResult(params) {
  const payload = await new PromModel().signupResult(params);
  return {
    type: SIGNUP_RESULT,
    payload
  }
}

// 提交报名
async function signupSubmit(params) {
  const payload = await new PromModel().signupSubmit(params);
  return {
    type: SIGNUP_SUBMIT,
    payload
  }
}

// 详情
async function signupPreviewDetail(params) {
  const payload = await new PromModel().signupPreviewDetail(params);
  return {
    type: SIGNUP_PREVIEW_DETAIL,
    payload
  }
}

// 查询活动状态
async function signupStatus(params) {
  const payload = await new PromModel().signupStatus(params);
  return {
    type: SIGNUP_STATUS,
    payload
  }
}

const ACTION_TYPES = {
  SIGNUP_LOGIN,
  SIGNUP_DETAIL,
  SIGNUP_CANCEL,
  SIGNUP_RESULT,
  SIGNUP_SUBMIT,
  SIGNUP_PREVIEW_DETAIL,
  SIGNUP_STATUS,
  GET_RULE,
};

const ACTION = {
  signupLogin,
  signupDetail,
  signupCancel,
  signupResult,
  signupSubmit,
  signupPreviewDetail,
  signupStatus,
  getRule,
};

const Signup = {
  ACTION_TYPES,
  ACTION
}

export default Signup;